import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { RequireFamily } from "../components/RequireFamily";
import { RouteLoading } from "../components/RouteLoading";

const LoginPage = lazy(() => import("../pages/LoginPage"));
const DashboardPage = lazy(() => import("../pages/DashboardPage"));
const LessonPage = lazy(() => import("../pages/LessonPage"));
const ClassroomPage = lazy(() => import("../pages/ClassroomPage"));
const EvidencePage = lazy(() => import("../pages/EvidencePage"));
const RetentionPage = lazy(() => import("../pages/RetentionPage"));
const ParentDataPage = lazy(() => import("../pages/ParentDataPage"));
const LearningTrialPage = lazy(() => import("../pages/LearningTrialPage"));

export function App() {
  return (
    <Suspense fallback={<RouteLoading />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireFamily />}>
          <Route element={<AppShell />}>
            <Route index element={<DashboardPage />} />
            <Route path="/lessons/:lessonId" element={<LessonPage />} />
            <Route path="/evidence/:lessonId" element={<EvidencePage />} />
            <Route path="/retention/:taskId" element={<RetentionPage />} />
            <Route path="/parent/data" element={<ParentDataPage />} />
            <Route path="/parent/trial" element={<LearningTrialPage />} />
          </Route>
          <Route
            path="/classroom/:sessionId"
            element={<ClassroomPage />}
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
